

import UiToolbar from 'keen-ui/src/UiToolbar';

export default {
  name: 'KeenUiToolbar',
  extends: UiToolbar,
};

